import { useCallback, useEffect, useState } from 'react';

import { apiV1Url } from '../lib/apiBaseUrl.ts';
import { creatorFetch } from '../services/creatorFetch.ts';

type HealthStatus = {
  healthy: boolean | null;
  checking: boolean;
  error: string | null;
};

export function useOrchestratorHealth() {
  const [healthStatus, setHealthStatus] = useState<HealthStatus>({
    healthy: null,
    checking: false,
    error: null
  });

  const checkHealth = useCallback(async () => {
    setHealthStatus((prev) => ({ ...prev, checking: true, error: null }));
    try {
      const res = await creatorFetch(apiV1Url('/api/v1/simpi-drafts/health'), { method: 'GET' });
      if (res.ok) {
        const data = (await res.json()) as { status?: string };
        const ok = (data?.status || '').toLowerCase() === 'healthy';
        setHealthStatus({ healthy: ok, checking: false, error: null });
      } else {
        let errText = 'Health check failed';
        try {
          const data = (await res.json()) as { error?: string };
          if (data?.error) errText = data.error;
        } catch {
          // ignore parse errors
        }
        setHealthStatus({ healthy: false, checking: false, error: errText });
      }
    } catch (e) {
      setHealthStatus({
        healthy: false,
        checking: false,
        error: e instanceof Error ? e.message : 'Unknown error'
      });
    }
  }, []);

  useEffect(() => {
    checkHealth();
    const interval = setInterval(checkHealth, 30000);
    return () => clearInterval(interval);
  }, [checkHealth]);

  return { healthStatus, checkHealth };
}

